export interface BlurOptions {
    blurValue: number;
    blurDisplay: boolean;
}

export const DefaultBlurOptions = {
    blurValue: 5,
    blurDisplay: false,
};
